import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpis-dc',
  templateUrl: './kpis-dc.component.html',
  styleUrls: ['./kpis-dc.component.scss']
})
export class KpisDcComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
